import React, {useState, useCallback, useEffect} from 'react'
import TableHead from './TablHead'
import Row from './Row'

import {CircularProgress, Stack} from '@mui/material'

import {useDispatch} from 'react-redux'
import {useTranslation} from 'react-i18next'
import {PaginationSection} from '../customTable/pagnationSection'
import Media from '../../Api/media'
import iMedia from '../../interface/iMedia'
import Search from '../customTable/Search'
import PageApi from '../../Api/Page'
import MenuApi from '../../Api/menu'
import Card from './Card'
import ServiseFees from '../../Api/serviseFees'
import NoDataTable from '../customTable/NoDataTable'
import NoNetWork from '../customTable/NoNetWork'
import ServiceFeesWarningBanner from './ServiceFeesWarningBanner'

export default function Table({
  rows,
  setRows,
  added,
  switchValue,
  refreshKey = 0,
  onUnpaidChange,
  isWhishEnabled = true,
  isPayingAll = false,
  canPay = false,
  onPayNow,
}: {
  rows: iMedia[] | never[]
  setRows: React.Dispatch<React.SetStateAction<iMedia[] | never[]>>
  added: boolean
  switchValue: string
  refreshKey?: number
  onUnpaidChange?: (total: number, currency: string) => void
  isWhishEnabled?: boolean
  isPayingAll?: boolean
  canPay?: boolean
  onPayNow?: () => void
}) {
  const [isLoading, setIsLoading] = useState(false)
  const [page, setPage] = useState<number>(1)
  const [rowsPerPage, setRowsPerPage] = useState<number>(5)
  const [search, setSearch] = useState('')
  const [total, setTotal] = useState(1)
  const [cards, setCards] = useState<any>({})
  const {t} = useTranslation()

  const getMedia = (searchText: string, rowsPerPage: number, page: number, switchValue: any) => {
    ServiseFees.get(
      searchText,
      rowsPerPage,
      page,
      switchValue,
      (res: any) => {
        setCards({
          total: res.data.total_of_service_fees,
          paid: res.data.paid_service_fees,
          unpaid: res.data.un_paid_service_fees,
        })

        setTotal(res.pages.total)

        const serviceFees = res.data.service_fees || []
        setRows(serviceFees)

        if (onUnpaidChange) {
          const unpaidRows = serviceFees.filter((row: any) => !row.paid_date)
          const unpaidSum = unpaidRows.reduce(
            (sum: number, row: any) => sum + (Number(row.total) || 0),
            0
          )
          const currency = unpaidRows[0]?.paid_currency_symbol || serviceFees[0]?.paid_currency_symbol || ''
          onUnpaidChange(unpaidSum, currency)
        }
      },
      setIsLoading
    )
  }
  const handleChangePage = (newPage: number) => {
    setPage(newPage)
  }
  const handleChangeRowsPerPage = (newPrePage: number) => {
    setRowsPerPage(newPrePage)
    setPage(1)
  }
  useEffect(() => {
    getMedia(search, rowsPerPage, page, switchValue)
  }, [rowsPerPage, page, switchValue, refreshKey])

  return (
    <NoNetWork>
      <>
        <div className='card-body py-3 pb-5'>
          <div className='table-responsive overflow-auto  '>
            <ServiceFeesWarningBanner
              rows={rows}
              isPayingAll={isPayingAll}
              isWhishEnabled={isWhishEnabled}
              canPay={canPay}
              onPayNow={onPayNow || (() => {})}
            />
            <Stack mb='15px' mt='14px' gap='32px' direction={'row'}>
              <Card
                bgcolor='#D8E2FC'
                data={{
                  name: 'totalServesFees',
                  value: cards.total,
                  tooltip: 'service_fees_tooltip_total',
                }}
              />
              <Card
                bgcolor='#DBE9E6'
                data={{
                  name: 'paidService',
                  value: cards.paid,
                  tooltip: 'service_fees_tooltip_paid',
                }}
              />
              <Card
                bgcolor='#F9E0E1'
                data={{
                  name: 'serviceFee',
                  value: cards.unpaid,
                  tooltip: 'service_fees_tooltip_unpaid',
                }}
              />
              {/* <Card data={{name: 'feePayable', value: 'IQ 2.25 M'}} /> */}
            </Stack>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <TableHead switchValue={switchValue} />
              {!added ? (
                <>
                  {' '}
                  {!isLoading ? (
                    <tbody className='mb-4'>
                      {rows.length === 0 ? (
                        <NoDataTable />
                      ) : (
                        rows.map((e, i) => (
                          <Row
                            switchValue={switchValue}
                            item={e}
                            i={i}
                            key={i}
                            isWhishEnabled={isWhishEnabled}
                          />
                        ))
                      )}
                    </tbody>
                  ) : (
                    <CircularProgress />
                  )}
                </>
              ) : (
                <h1>loading</h1>
              )}
            </table>
            <PaginationSection
              rowsPerPageOptions={[5, 20, 30, 40, 50, 60]}
              count={total || 1}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
            {/* pagnation  item   */}
          </div>
        </div>
      </>{' '}
    </NoNetWork>
  )
}
